import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GeoFenceService {

  google: any;

  constructor(){}

  showRectangleFence(data, inside, mapRef) {
    const dataObj = JSON.parse(data);
    const map = mapRef;
    const rectangle = {
      fillColor: inside ? "#40ec40" : "#ff0000",
      strokeColor: inside ? "green" : "red",
      strokeWeight: 1,
      map,
      value: {
        center: {
          lat: dataObj.center.lat,
          lng: dataObj.center.lng
        }
      },
      bounds: {
        north: dataObj.bounds.north,
        south: dataObj.bounds.south,
        east: dataObj.bounds.east,
        west: dataObj.bounds.west,
      },
    };
    return rectangle;
    // this.batchOverlays.push(rectangle);
  }
        
  showCircleFence(data, inside, mapRef) {
    const dataObj = JSON.parse(data);
    // console.log(dataObj, data, 'circle');
    const map = mapRef;
    const circle = {
      fillColor: inside ? "#40ec40" : "#ff0000",
      strokeColor: inside ? "green" : "red",
      strokeWeight: 1,
      strokeOpacity: 0.8,
      fillOpacity: 0.35,
      map,
      center: {
        lat: dataObj.center.lat,
        lng: dataObj.center.lng,
      },
      radius: dataObj.radius
    };
    return circle;
  }

  showPolygonFence(data, inside, mapRef) {
    let dataObj = JSON.parse(data);
    // console.log(dataObj, data, 'polygon');
    const map = mapRef;
    let newDataObj = dataObj.path.split("),(");
    for (var i = 0; i < newDataObj.length; i++) {
      let vals = newDataObj[i].split(', ');
      let latVal: string, lngVal: string;
      if (i === 0) {
        latVal = vals[0].replace('(', '');
        lngVal = vals[1];
        newDataObj[i] = { lat: parseFloat(latVal), lng: parseFloat(lngVal) };
      } else if (i === newDataObj.length - 1) {
        latVal = vals[0];
        lngVal = vals[1].replace(')', '');
        newDataObj[i] = { lat: parseFloat(latVal), lng: parseFloat(lngVal) };
      } else {
        newDataObj[i] = { lat: parseFloat(vals[0]), lng: parseFloat(vals[1]) };
      }
    }
    const polygonOverlay = {
      path: newDataObj,
      geodesic: true,
      fillColor: inside ? "#40ec40" : "#ff0000",
      strokeColor: inside ? "green" : "red",
      strokeWeight: 1
    };
    
    return polygonOverlay;
  }

  showPolyLineFence(data, inside, mapRef) {
    let dataObj = JSON.parse(data);
    const map = mapRef;
    let newDataObj = dataObj.path.split("),(");
    for (var i = 0; i < newDataObj.length; i++) {
      let vals = newDataObj[i].split(', ');
      let latVal: string, lngVal: string;
      if (i === 0) {
        latVal = vals[0].replace('(', '');
        lngVal = vals[1];
        newDataObj[i] = { lat: parseFloat(latVal), lng: parseFloat(lngVal) };
      } else if (i === newDataObj.length - 1) {
        latVal = vals[0];
        lngVal = vals[1].replace(')', '');
        newDataObj[i] = { lat: parseFloat(latVal), lng: parseFloat(lngVal) };
      } else {
        newDataObj[i] = { lat: parseFloat(vals[0]), lng: parseFloat(vals[1]) };
      }
    }
    const polyLineOverlay = {
      path: newDataObj,
      geodesic: true,
      fillColor: inside ? "#40ec40" : "#ff0000",
      strokeColor: inside ? "green" : "red",
      strokeWeight: 1
    };
    return polyLineOverlay;
  }
  
  // regional fence type latlng setup
  getLatLngArr(geoJson) {
    var locations = geoJson.geojson.coordinates
    var latlonArr = [];
    if (geoJson.geojson.type == 'MultiPolygon') {
      locations.forEach(outerArr => {
        outerArr.forEach(innerArr => {
          var lArr = [];
          innerArr.forEach(locArr => {
            lArr.push({
              lat: locArr[1],
              lng: locArr[0]
            });
          });
          latlonArr.push(lArr);
        });
      });
    }
    if (geoJson.geojson.type == 'Polygon') {
      locations.forEach(outerArr => {
        var lArr = [];
        outerArr.forEach(locArr => {
          lArr.push({
            lat: locArr[1],
            lng: locArr[0]
          });
        });
        latlonArr.push(lArr);
      });
    }
    return latlonArr;
  }
}